import { schedularAnnouncementActions } from './constant';

const {
  GET_ALL_ANNOUNCEMENTS_REQUEST,
  GET_ALL_ANNOUNCEMENTS_RESET,
  CREATE_ANNOUNCEMENT_REQUEST,
  CREATE_ANNOUNCEMENT_RESET,
  UPDATE_ANNOUNCEMENT_REQUEST,
  UPDATE_ANNOUNCEMENT_RESET,
  DELETE_ANNOUNCEMENT_REQUEST,
  DELETE_ANNOUNCEMENT_RESET,
} = schedularAnnouncementActions;

export const getAllAnnouncementsAction = (payload: any) => {
  return {
    type: GET_ALL_ANNOUNCEMENTS_REQUEST,
    payload,
  };
};

export const resetGetAllAnnouncementsAction = () => {
  return {
    type: GET_ALL_ANNOUNCEMENTS_RESET,
  };
};

export const createAnnouncementAction = (payload: any) => {
  return {
    type: CREATE_ANNOUNCEMENT_REQUEST,
    payload,
  };
};

export const resetCreateAnnouncementAction = () => {
  return {
    type: CREATE_ANNOUNCEMENT_RESET,
  };
};

export const updateAnnouncementAction = (payload: any) => {
  return {
    type: UPDATE_ANNOUNCEMENT_REQUEST,
    payload,
  };
};

export const resetUpdateAnnouncementAction = () => {
  return {
    type: UPDATE_ANNOUNCEMENT_RESET,
  };
};

export const deleteAnnouncementAction = (payload: any) => {
  return {
    type: DELETE_ANNOUNCEMENT_REQUEST,
    payload,
  };
};

export const resetDeleteAnnouncementAction = () => {
  return {
    type: DELETE_ANNOUNCEMENT_RESET,
  };
};
